// Authentication related sagas

import { put, select } from 'redux-saga/effects';

// Services
import { ErrorCategory, handleError } from '@services/errorService';

// Api
import client from '@api';

// Actions
import { UpdateMarkup, UpdatedMarbleUserAuths } from '@actions/user';
import { GetAccountFeed } from '@actions/feed';
import { ClearPosts } from '@actions/posts';

// Graph
import { logoutFromApp } from '@graphql/mutations/account';

// Queries
import { getMarkupQuery } from '@graphql/queries/account';

// Types
import type { Auth, PayloadAction } from './types';

export function* UserLogoutFromAppSaga({
  payload,
}: PayloadAction<string>): Generator {
  try {
    const auths = (yield select(
      (state: { User: { auths: Auth[] } }) => state.User.auths,
    )) as Auth[];
    const authId = auths.find((auth) => auth.source === payload)?._id;
    const { _id: accountId } = (yield select(
      (state: { User: { _id: string } }) => state.User,
    )) as { _id: string };

    const {
      data: { authDisconnect },
    } = (yield client().mutate({
      mutation: logoutFromApp,
      variables: { input: { authId } },
    })) as { data: { authDisconnect: Auth[] } };

    yield put(ClearPosts());
    yield put(GetAccountFeed({ accountId, skip: 0 }));
    yield put(UpdatedMarbleUserAuths({ auths: authDisconnect }));

    const {
      data: {
        me: {
          backgroundSettings: { markup },
        },
      },
    } = (yield client().query({
      query: getMarkupQuery,
    })) as { data: { me: { backgroundSettings: { markup: unknown } } } };

    yield put(UpdateMarkup(markup));
  } catch (error) {
    handleError(error, { category: ErrorCategory.API });
  }
}
